__webpack_require__.p = "/microgpt_lab/";